export const ADD_MESSAGE = "ADD_MESSAGE";
export const ADD_MESSAGEHEADER = "ADD_MESSAGEHEADER";
export const ADD_VALUESHEADER = "ADD_VALUESHEADER";
export const ADDMSGRECEIVED = "ADDMSGRECEIVED";
export const ADD_ATENDIMENTO = "ADD_ATENDIMENTO";
export const ADD_STATUS = "ADD_STATUS";
export const ADD_TIME = "ADD_TIME";
export const ADD_BLOCKFUTURE = "ADD_BLOCKFUTURE";
export const ADD_IPCURRENT = "ADD_IPCURRENT";
export const ADD_DETAILS = "ADD_DETAILS";
export const ADD_QUEUE = "ADD_QUEUE";
export const ADD_AGENTS = "ADD_AGENTS";
export const ADD_CALLBACK = "ADD_CALLBACK";
export const ADD_ACTIVECALL = "ADD_ACTIVECALL";

export const ATENDIMENTO_LIST = "ATENDIMENTO_LIST";
export const ATD_SIMULT = "ATD_SIMULT";
export const ATD_DEL = "ATD_DEL";
export const EDIT_QTD_MSG = "EDIT_QTD_MSG";
export const CLEAR_QTD_MSG = "CLEAR_QTD_MSG";

export const EDIT_ATENDIMENTO_A = "EDIT_ATENDIMENTO_A";
export const EDIT_ATENDIMENTO_C = "EDIT_ATENDIMENTO_C";
export const EDIT_ATENDIMENTO_E = "EDIT_ATENDIMENTO_E";
export const EDIT_MESSAGEID = "EDIT_MESSAGEID";
export const EDIT_MARKSTAR = "EDIT_MARKSTAR";
export const EDIT_QUEUE = "EDIT_QUEUE";
export const EDIT_AGENTS = "EDIT_AGENTS";
export const EDIT_AGENTS_JSON = "EDIT_AGENTS_JSON";
export const EDIT_CALLBACK = "EDIT_CALLBACK";
export const EDIT_PERMISSIONS_INGDESK = "EDIT_PERMISSIONS_INGDESK";

export const DELETE_QUEUE = "DELETE_QUEUE";

export const DETAILSANOTATIONS = "DETAILSANOTATIONS";
export const DETAILSMARKSTAR = "DETAILSMARKSTAR";
export const DETAILSFILESHARED = "DETAILSFILESHARED";
export const DETAILSMANAGER = "DETAILSMANAGER";
export const DETAILSCONTACTS = "DETAILSCONTACTS";

export const CLEAR_MESSAGE = "CLEAR_MESSAGE";
export const CLEAR_MESSAGEHEADER = "CLEAR_MESSAGEHEADER";
export const CLEAR_BLOCK = "CLEAR_BLOCK";
export const CLEAR_RETURN = "CLEAR_RETURN";
export const SHOW_MODAL = "SHOW_MODAL";
export const NUMBERSCONTACT = "NUMBERSCONTACT";

export const RETURN_QUEUE = "RETURN_QUEUE";
export const RETURN_QUEUEOBS = "RETURN_QUEUEOBS";

export const LIST_QUEUE = "LIST_QUEUE";
export const CONTACTS = "CONTACTS";
export const USRMSGLOG = "USRMSGLOG";
export const MESSAGE_RECEIVED = "MESSAGE_RECEIVED";
export const RESP_ATD = "RESP_ATD";
export const MENU = "MENU";
export const PASSWORD = "PASSWORD";
export const BLOCK = "BLOCK";
export const HISTORY = "HISTORY";
export const GROUP = "GROUP";
export const TYPING_ADD = "TYPING_ADD";
export const TYPING_EDIT = "TYPING_EDIT";
export const SERVICELOGINID = "SERVICELOGINID";
export const QUEUEPERMISSION = "QUEUEPERMISSION";
export const INFOUSER = "INFOUSER";
export const UPLOADPROGRESS = "UPLOADPROGRESS";
export const IVR = "IVR";
export const GETCEP = "GETCEP";
export const DETAILS = "DETAILS";
export const ERRORLOGIN = "ERRORLOGIN";
export const ERRORSENHA = "ERRORSENHA";
export const SHOWNOTIFIER = "SHOWNOTIFIER";
export const AUTHSUCESS = "AUTHSUCESS";
export const TOGGLE_VISIBLE = "TOGGLE_VISIBLE";
export const TOGGLE_DISPLAY = "TOGGLE_DISPLAY";
export const TOGGLE_VISIBLE_DT = "TOGGLE_VISIBLE_DT";
export const RESPOSTASRAPIDAS = "RESPOSTASRAPIDAS";
export const CRITICALITY = "CRITICALITY";
export const ROUTERGROUP = "ROUTERGROUP";
export const OUTSERVICE = "OUTSERVICE";
export const COMPANYS = "COMPANYS";
export const HISTORYCCALLS = "HISTORYCCALLS";
export const REMOVE_ATDUNIQUE = "REMOVE_ATDUNIQUE";
export const TYPENUMBERS = "TYPENUMBERS";
export const SERVICEGROUP = "SERVICEGROUP";
export const LISTSUPGROUP = "LISTSUPGROUP";
export const DELNUMBERCONTACT = "DELNUMBERCONTACT";
export const EDITNUMBERCONTACT = "EDITNUMBERCONTACT";
export const EDITTYPENUMBERCONTACT = "EDITTYPENUMBERCONTACT";
export const ADD_NUMBER_CONTACT = "ADD_NUMBER_CONTACT";
export const MIDIAS = "MIDIAS";
export const SERVICOAGRUPADO = "SERVICOAGRUPADO";
export const GROUP_VISIBLE = "GROUP_VISIBLE";
export const INTERACTIONS_NUMBER = "INTERACTIONS_NUMBER";
export const DELCONTACT = "DELCONTACT";
export const DELCOMPANY = "DELCOMPANY";
export const CLEARCONTACTS = "CLEARCONTACTS";
export const CHAT_DEL = "CHAT_DEL";
export const CHAT_SIMULT = "CHAT_SIMULT";
export const ADD_CHAT = "ADD_CHAT";
export const EDIT_TIMEATD = "EDIT_TIMEATD";
export const EDIT_MULTIPLES = "EDIT_MULTIPLES";
export const EDIT_ATENDIMENTO_D = "EDIT_ATENDIMENTO_D";
export const EDITUSER = "EDITUSER";
export const EDIT_ATD_SIMULT = "EDIT_ATD_SIMULT";
export const EDIT_AGENTS_BLOCK = "EDIT_AGENTS_BLOCK";
export const EDIT_STATUSMSG = "EDIT_STATUSMSG";
export const ADD_NOTIFIER = "ADD_NOTIFIER";
export const EDIT_NOTIFIER = "EDIT_NOTIFIER";
export const LIST_NOTIFIER = "LIST_NOTIFIER";
export const DELETE_NOTIFIER = "DELETE_NOTIFIER";
export const CURRENTSCREEN = "CURRENTSCREEN";
export const CAP_QUEUE = "CAP_QUEUE";
export const REMOVE_CHATUNIQUE = "REMOVE_CHATUNIQUE";
export const EDIT_CHAT_SIMULT = "EDIT_CHAT_SIMULT";
export const DELETE_NOT_REMOTE = "DELETE_NOT_REMOTE";
export const CONNECTIONAPI = "CONNECTIONAPI";
export const MONITORING_SIMULT = "MONITORING_SIMULT";
export const ADD_MONITORING = "ADD_MONITORING";
export const ADD_MONITORING_SIMULT = "ADD_MONITORING_SIMULT";
export const ADD_CLIENT_MONITORING = "ADD_CLIENT_MONITORING";
export const EDIT_GROUP = "EDIT_GROUP";
export const MONITORING_DEL = "MONITORING_DEL";
export const REMOVE_USER_MONITORING = "REMOVE_USER_MONITORING";
export const EDIT_MONITORING_M = "EDIT_MONITORING_M";
export const EDIT_MONITORING_S = "EDIT_MONITORING_S";
export const CLEAR_MESSAGE_MON = "CLEAR_MESSAGE_MON";
export const REMOVE_CLIENT_MONITORING = "REMOVE_CLIENT_MONITORING";
export const EDIT_MONITORING_C = "EDIT_MONITORING_C";
export const EDIT_MONITORING_D = "EDIT_MONITORING_D";
export const EDIT_ATENDIMENTO_VOZ = "EDIT_ATENDIMENTO_VOZ";
export const EDIT_MULTIPLES_VOZ = "EDIT_MULTIPLES_VOZ";
export const CONSULTA_ATD = "CONSULTA_ATD";
export const REFRESH_QUEUE_STATUS = "REFRESH_QUEUE_STATUS";
export const REFRESH_QUEUE_ID = "REFRESH_QUEUE_ID";
export const PHONEMIDIA = "PHONEMIDIA";
export const END_CALL = "END_CALL";
export const REFRESH_NO_ANSWER = "REFRESH_NO_ANSWER";
export const ENABLECALL = "ENABLECALL";
export const EDITERRORINSERT = "EDITERRORINSERT";
export const CHANGERECORDER = "CHANGERECORDER";
export const EDITMSG = "EDITMSG";
export const BLOCKFUTURE = "BLOCKFUTURE";
export const BLOCKSCREEN = "BLOCKSCREEN";
export const EDIT_CHAT_VOZ = "EDIT_CHAT_VOZ";
export const EDIT_VOZ_INTERNAL = "EDIT_VOZ_INTERNAL";
export const START_FILTERS = "START_FILTERS";
export const FILTRO_CALLBACK = "FILTRO_CALLBACK";
export const FILTRO_FILA = "FILTRO_FILA";
export const FILTRO_TRATAMENTO = "FILTRO_TRATAMENTO";
export const ARRAY_FILA = "ARRAY_FILA";
export const CONTACT_INFO = "CONTACT_INFO";
export const FILTRO_RETORNO = "FILTRO_RETORNO";
export const AUTOMATIC_PAUSE = "AUTOMATIC_PAUSE";
export const ERRORHOUR = "ERRORHOUR";
export const EDIT_BLOCK_USER = "EDIT_BLOCK_USER";
export const REASONBLOCK = "REASONBLOCK";
export const CHANGE_AUDIO_INTERACTION = "CHANGE_AUDIO_INTERACTION";
export const CHANGE_AUDIO_MESSAGE = "CHANGE_AUDIO_MESSAGE";
export const CHANGE_AUDIO_CALL = "CHANGE_AUDIO_CALL";
export const EDIT_REPLY_OP = "EDIT_REPLY_OP";
export const LISTGROUPMSG = "LISTGROUPMSG";
export const EDIT_INFO_CLI = "EDIT_INFO_CLI";
export const REMOVE_CONFERENCE_CLI = "REMOVE_CONFERENCE_CLI";
export const ADD_SERVICE_URL = "ADD_SERVICE_URL";
export const ADD_CONFERENCE_CLI = "ADD_CONFERENCE_CLI";
export const CLEAR_CONFERENCE_CLI = "CLEAR_CONFERENCE_CLI";
export const EDIT_VOZ_INTERNAL_LINE = "EDIT_VOZ_INTERNAL_LINE";
export const END_CALL_LINE = "END_CALL_LINE";
export const EDIT_CHAT_VOZ_LINE = "EDIT_CHAT_VOZ_LINE";
export const LIST_DEVICE = "LIST_DEVICE";
export const LIST_DEVICE_DEFAULT = "LIST_DEVICE_DEFAULT";
export const EDIT_SUPERINFO = "EDIT_SUPERINFO";
export const EDIT_MODAL_PAUSE = "EDIT_MODAL_PAUSE";
export const EDIT_ACW_CONTACT = "EDIT_ACW_CONTACT";
export const BLOCKNC2 = "BLOCKNC2";
export const SUPBLOCK = "SUPBLOCK";
export const EDIT_INDICATORS = "EDIT_INDICATORS";
export const EDIT_USER_SCHEDULE_REASONS_NC2 = "EDIT_USER_SCHEDULE_REASONS_NC2";
export const EDIT_USER_SCHEDULE_NUMBERS_NC2 = "EDIT_USER_SCHEDULE_NUMBERS_NC2";
export const EDIT_USER_SCHEDULE_CONFIRM_NC2 = "EDIT_USER_SCHEDULE_CONFIRM_NC2";
export const EDIT_USER_URL_NC2 = "EDIT_USER_URL_NC2";
export const EDIT_USER_TYPE_NC2 = "EDIT_USER_TYPE_NC2";
export const EDIT_USER_INFO_NC2 = "EDIT_USER_INFO_NC2";
export const EDIT_MENU_BOT = "EDIT_MENU_BOT";
export const EDIT_USER_LOGIN_RESPONSE = "EDIT_USER_LOGIN_RESPONSE";
export const EDIT_MENU_BOT_DATA = "EDIT_MENU_BOT_DATA";
export const EDIT_USER_LOGIN_NC2 = "EDIT_USER_LOGIN_NC2";
export const EDIT_NUMBERS_DISPONIBLES_CHANNEL =
  "EDIT_NUMBERS_DISPONIBLES_CHANNEL";
export const EDIT_ID_SERVICEATD = "EDIT_ID_SERVICEATD";
export const CHANGE_BLOCK = "CHANGE_BLOCK";
export const CHANGE_PERMISSION = "CHANGE_PERMISSION";
export const INFOUSERLOGINSUCESS = "INFOUSERLOGINSUCESS";
export const REF_IFRAME_INGDESK = "REF_IFRAME_INGDESK";
export const CHANGE_IS_INGDESK = "CHANGE_IS_INGDESK";
export const ADD_INTERACTION = "ADD_INTERACTION";
export const REMOVE_INTERACTION = "REMOVE_INTERACTION";
export const IS_SAVE_INTERACTION = "IS_SAVE_INTERACTION";
export const IS_SAVE_CLIENT_INTERACTION = "IS_SAVE_CLIENT_INTERACTION";
export const CHANGE_TOKEN_INGDESK_ENDPOINT = "CHANGE_TOKEN_INGDESK_ENDPOINT";
export const CHANGE_IS_INGDESK_SUCCESS = "CHANGE_IS_INGDESK_SUCCESS";
export const LINK_COPIED = "LINK_COPIED";
export const EDIT_INFO_MAIL = "EDIT_INFO_MAIL";
export const ADD_MESSAGE_MAIL = "ADD_MESSAGE_MAIL";
export const DEL_MESSAGE_MAIL = "DEL_MESSAGE_MAIL";
export const ADD_TABULATOR = "ADD_TABULATOR";
export const DEVICE_MICROFONE = "DEVICE_MICROFONE";
export const DEVICE_AUDIO = "DEVICE_AUDIO";
export const DEVICE_RING = "DEVICE_RING";
export const CALLPARK = "CALLPARK";
export const EDIT_FUTURE_BREAK = "EDIT_FUTURE_BREAK";
export const EDIT_SURVEY = "EDIT_SURVEY";
export const CHANGE_ACTIVEHEADER = "CHANGE_ACTIVEHEADER";
export const EDIT_CHAT_SIMULT_ATENDIMENTO = "EDIT_CHAT_SIMULT_ATENDIMENTO";
export const INTERACTIONS_MODAL = "INTERACTIONS_MODAL";
export const EDIT_SUBJECT_MAIL = "EDIT_SUBJECT_MAIL";
export const ADD_ATTACHMENTS_MAIL = "ADD_ATTACHMENTS_MAIL";

export const CHANGE_FILTERS_NPS = "CHANGE_FILTERS_NPS";
export const NPS_DETAILS = "NPS_DETAILS";
export const ADD_ANSWER_HIDDEN = "ADD_ANSWER_HIDDEN";
export const REMOVE_ANSWER_HIDDEN = "REMOVE_ANSWER_HIDDEN";
export const CLEAR_NPS_DETAILS = "CLEAR_NPS_DETAILS";
export const EDIT_NPS_DETAILS = "EDIT_NPS_DETAILS";
export const EDIT_ACW_CONTACT_DISABLED = "EDIT_ACW_CONTACT_DISABLED";
export const EDIT_IS_TABULATION = "EDIT_IS_TABULATION";
export const DELETE_MESSAGE = "DELETE_MESSAGE";

export const CHANGE_FILTERS_AGENT_DASHBOARD = "CHANGE_FILTERS_AGENT_DASHBOARD";

export const SELECTEC_SIDE_CONTENT_ATTENDANCE =
  "SELECTEC_SIDE_CONTENT_ATTENDANCE";

export const CHANGE_MESSAGE_FROM_HELP_SIDE_CONTENT =
  "CHANGE_MESSAGE_FROM_HELP_SIDE_CONTENT";
export const CHANGE_ISLOADING_SIDE_CONTENT = "CHANGE_ISLOADING_SIDE_CONTENT";

export const EDIT_CALL_CENTER_CSAT = "EDIT_CALL_CENTER_CSAT";

export const CHANGE_STATUS_OF_INGFAQ_CONDITIONS =
  "CHANGE_STATUS_OF_INGFAQ_CONDITIONS";

export const ADD_QUARENTINE_QUEUE = "ADD_QUARENTINE_QUEUE";
export const REMOVE_QUARENTINE_QUEUE = "REMOVE_QUARENTINE_QUEUE";
export const EDIT_NUMBER_OF_UNREAD_MESSAGES_OF_QUARENTINE_QUEUE =
  "EDIT_NUMBER_OF_UNREAD_MESSAGES_OF_QUARENTINE_QUEUE";
export const ADD_CONTACTIDS_TO_QUARENTINE = "ADD_CONTACTIDS_TO_QUARENTINE";
export const REMOVE_CONTACTIDS_TO_QUARENTINE =
  "REMOVE_CONTACTIDS_TO_QUARENTINE";
export const ADD_ONE_MORE_UNREADED_MESSAGE_OF_QUARENTINE_QUEUE =
  "ADD_ONE_MORE_UNREADED_MESSAGE_OF_QUARENTINE_QUEUE";
export const ADD_ONE_MORE_UNREAD_MESSAGES_QUEUE =
  "ADD_ONE_MORE_UNREAD_MESSAGES_QUEUE";

export const EDIT_INITIAL_DATE_FILTER_QUARENTINE =
  "EDIT_INITIAL_DATE_FILTER_QUARENTINE";
export const EDIT_FINAL_DATE_FILTER_QUARENTINE =
  "EDIT_FINAL_DATE_FILTER_QUARENTINE";
export const CHANGE_NEXT_CALL_QUEUE_TAB = "CHANGE_NEXT_CALL_QUEUE_TAB";
export const CHANGE_WAITING_CALL_QUEUE_TAB = "CHANGE_WAITING_CALL_QUEUE_TAB";
export const CHANGE_CHAT_CALL_QUEUE_TAB = "CHANGE_CHAT_CALL_QUEUE_TAB";
export const SEND_QUEUE_STANDBY = "SEND_QUEUE_STANDBY";
export const CLEAR_QUARENTINE_ALL = "CLEAR_QUARENTINE_ALL";
export const CLEAR_ATD_ALL = "CLEAR_ATD_ALL";
export const CLEAR_ATD_SIMULT_ALL = "CLEAR_ATD_SIMULT_ALL";
export const CHANGE_RECONNECT_MODAL_STATUS = "CHANGE_RECONNECT_MODAL_STATUS";
export const CHANGE_NUMBER_OF_UNREADED_MESSAGES_OF_AN_ITEM =
  "CHANGE_NUMBER_OF_UNREADED_MESSAGES_OF_AN_ITEM";
export const CLEAR_MESSAGE_ALL = "CLEAR_MESSAGE_ALL";

export const EDIT_QTD_MSG_MONITORING = "EDIT_QTD_MSG_MONITORING";
export const EDIT_TOTAL_QTD_MSG_MONITORING = "EDIT_TOTAL_QTD_MSG_MONITORING";
export const CLEAR_QTD_MSG_MONITORING = "CLEAR_QTD_MSG_MONITORING";
export const EDIT_IS_FROM_STANDBY_MONITORING =
  "EDIT_IS_FROM_STANDBY_MONITORING";

export const ADD_TMNOREPLY_PER_AGENT = "ADD_TMNOREPLY_PER_AGENT";

export const CLEAR_GETCEP = "CLEAR_GETCEP";

export const ADD_ENTERPRISE_ADDITIONAL_INFOS =
  "ADD_ENTERPRISE_ADDITIONAL_INFOS";
export const ADD_CONTACT_ADDITIONAL_INFOS = "ADD_CONTACT_ADDITIONAL_INFOS";

export const ADD_MESSAGES_IN_BATCH = "ADD_MESSAGES_IN_BATCH";

export const ADD_ROUTER_GROUP_GROUPED_BY_MIDIA_ID =
  "ADD_ROUTER_GROUP_GROUPED_BY_MIDIA_ID";

export const CHANGE_LAST_CDR_CLICKED = "CHANGE_LAST_CDR_CLICKED";
export const ADD_MESSAGES_IN_BATCH_REVERSE_MODE =
  "ADD_MESSAGES_IN_BATCH_REVERSE_MODE";

export const CHANGE_SELECTED_CHAT_MONITORING =
  "CHANGE_SELECTED_CHAT_MONITORING";

export const CHANGE_IS_OPEN_FAQ_DRAGABLE = "CHANGE_IS_OPEN_FAQ_DRAGABLE";

export const EDIT_CLIENT_WALLET = "EDIT_CLIENT_WALLET";

//filtros de fila
export const ADICIONAR_VALORES_INICIAIS_DO_FILTRO_DE_FILA =
  "ADICIONAR_VALORES_INICIAIS_DO_FILTRO_DE_FILA";
export const MODIFICAR_VALORES_DO_CANAL_DO_FILTRO_DE_FILA =
  "MODIFICAR_VALORES_DO_CANAL_DO_FILTRO_DE_FILA";

//parte de desabilitar botão do standby
export const DESABILITAR_BOTAO_ATENDER_STANDBY =
  "DESABILITAR_BOTAO_ATENDER_STANDBY";
export const HABILITAR_BOTAO_ATENDER_STANDBY =
  "HABILITAR_BOTAO_ATENDER_STANDBY";
